
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import AnimateInView from '@/components/ui/animate-in-view';
import GoldSectionDivider from '@/components/ui/gold-section-divider';

// Fence compatibility data
const compatibleFences = [
  { type: "Chain Link", compatibility: "Excellent" },
  { type: "Wrought Iron", compatibility: "Excellent" },
  { type: "Wooden Privacy", compatibility: "Very Good" },
  { type: "Concrete/Stone", compatibility: "Good" },
  { type: "Vinyl/PVC", compatibility: "Good" },
  { type: "Mesh Security", compatibility: "Excellent" }
];

const FenceCompatibility = () => {
  return (
    <section className="section bg-white" aria-labelledby="compatibility-heading">
      <div className="container mx-auto max-w-3xl">
        <div className="flex flex-col items-center mb-8">
          <GoldSectionDivider centered />
          <h2 id="compatibility-heading" className="text-center text-boundri-DEFAULT mb-2">
            Fence Compatibility
          </h2>
        </div>
        <AnimateInView>
          <p className="text-center mb-8 text-boundri-charcoal">
            Our system works with virtually any fence type. See how well it integrates with your existing perimeter.
          </p>
        </AnimateInView>
        
        <AnimateInView animation="fade-in">
          <div className="overflow-hidden rounded-lg border border-boundri-lavender/30">
            <table className="min-w-full divide-y divide-boundri-lavender/30">
              <thead className="bg-boundri-background">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-boundri-DEFAULT uppercase tracking-wider">
                    Fence Type
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-boundri-DEFAULT uppercase tracking-wider">
                    Compatibility
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-boundri-lavender/30">
                {compatibleFences.map((fence, index) => (
                  <tr key={index} className="hover:bg-boundri-background/30 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap text-boundri-charcoal">
                      {fence.type}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        fence.compatibility === 'Excellent' 
                          ? 'bg-green-100 text-green-800' 
                          : fence.compatibility === 'Very Good' 
                            ? 'bg-blue-100 text-blue-800' 
                            : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {fence.compatibility}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </AnimateInView>
        
        <AnimateInView delay={300}>
          <div className="text-center mt-8">
            <p className="text-boundri-charcoal mb-4">
              Not sure if your fence is compatible? Our specialists can provide a free assessment.
            </p>
            <Button asChild variant="outline">
              <Link to="/contact">
                Request Compatibility Check
              </Link>
            </Button>
          </div>
        </AnimateInView>
      </div>
    </section>
  );
};

export default FenceCompatibility;
